/*** IMPORTS FROM imports-loader ***/
import "core-js/modules/es.promise";
import "core-js/modules/es.array.iterator";

import Cookies from 'js-cookie';
import toastify from 'toastify-js';

export default async (toasts, cookieName, cookieOptions) => {
	const ids = toasts.map(toast => toast.id),
		cookieIds = JSON.parse(Cookies.get(cookieName) || '[]'),
		shownIds = cookieIds.filter(id => ids.indexOf(id) >= 0);

	// Remove IDs from cookie that are not active anymore
	if (cookieIds.length !== shownIds.length) {
		Cookies.set(cookieName, JSON.stringify(shownIds), cookieOptions);
	}

	// Get toasts that are not shown yet
	const newToasts = toasts.filter(toast => shownIds.indexOf(toast.id) < 0);
	if (newToasts.length) {
		const addShownId = id => {
			shownIds.push(id);
			Cookies.set(cookieName, JSON.stringify(shownIds), cookieOptions);
		};

		newToasts.forEach(toast => {

			var parser = new DOMParser();
			var toastText = parser.parseFromString(toast.text, 'text/html').querySelector('.toast__content');

			toastify({
				className: 'toast',
				node: toastText,
				duration: 8000,
				gravity: 'top',
				position: 'right',
				close: true,
				stopOnFocus: true,
				onClick: () => {
					addShownId(toast.id);
					window.location = toast.url;
				},
				callback: () => {
					addShownId(toast.id);
				}
			}).showToast();
		});
	}
};